import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'phx-dialog-report',
    templateUrl: './dialog-report.component.html',
    styleUrls: ['./dialog-report.component.scss'],
    standalone: false
})
export class DialogReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
